
import { App } from 'vue'

const DEFAULTS = {
  // {string} Property name of the component's unique identifier. Change this if 'vm.uid' conflicts
  // with another plugin or your own props.
  uidProperty: 'uid',

  // {string} Prefix to use when generating HTML ids. Change this to make your ids more unique on a
  // page that already uses or could use a similar naming scheme.
  uidPrefix: 'uid-'
}
const Plugin = {
  install (app: App, options: any = {}): void {
    // Don't use object spread to merge the defaults because bublé transforms that to Object.assign
    const uidProperty = options.uidProperty || DEFAULTS.uidProperty
    const uidPrefix = options.uidPrefix || DEFAULTS.uidPrefix

    // Assign a unique id to each component
    let uidCounter = 0
    app.mixin({
      beforeCreate () {
        uidCounter += 1
        const uid = uidPrefix + uidCounter
        Object.defineProperties(this, {
          [uidProperty]: { get () { return uid } }
        })
      },
      methods: {
        $id (namespace = '') {
          return `${this[uidProperty]}-${namespace}`
        },
        $idRef (namespace = '') {
          return `#${this.$id(namespace)}`
        }
      }
    })
  }
}

export default Plugin
